// Paths viewable without a login (no redirect to /login, no menu bar)
export const isPublicPath = (pathname: string): boolean =>
  pathname.startsWith('/ohsnap365');

export const getUsernameFromToken = (): string | null => {
  const token = localStorage.getItem('loginToken');
  if (!token) return null;

  try {
    const payload = token.split('.')[1];
    if (!payload) return null;

    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    const decoded = JSON.parse(jsonPayload);
    return decoded.username || null;
  } catch {
    return null;
  }
};
